import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetPoData } from "../../../APIServices/ProductionService/ProductionFgService/ProductionFgThunk";
import { useTranslation } from 'react-i18next'; 
import "./ProductionFg.css";

const ProductionFgTiles = ({ handleReceiptClick, handleTransferClick, currentData }) => {
    const { ProdFgData } = useSelector((state) => state.ProductionFg);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        // Check if DisassembleData is not loaded yet, and dispatch the API call
        if (!ProdFgData || ProdFgData.length === 0) {
            dispatch(GetPoData());
        }
    }, [ProdFgData, dispatch]);
    // const hasReceipt = Array.isArray(currentData) && currentData.some(item => item.count > 0);
    
    return (
        <div className="disassemble-tiles-main">
            {currentData && currentData.length === 0 ? (
                <p className="no-data-message">No data available</p>
            ) : (
               currentData.map((item, index) => (
                    <div className={`disassemble-tiles ${item.receipt_Count >= item.planned_Qty ? "" : item.count > 0 ? "green-border" : ""}`}
                        key={index}>
                        <div className="d-flex">
                            <div className="ProductionFg-tiles-text">
                                <p>{t('Order No')}</p>
                                <p>{t('Item Code')}</p>
                                <p>{t('Item Name')}</p>
                                <p>{t('Planned Qty')}</p>
                                <p >{t('Transferred')}</p>
                                <p >{t('Receipt Count')}</p>
                            </div>
                            <div className="query-data-fg">
                                <p>{item.order_No} - {item.Order_Date}</p>
                                <p>{item.item_Code}</p>
                                <p>{item.item_Name}</p>
                                <p>{item.planned_Qty.toLocaleString()}</p>
                                <p>{item.transfered_Count}</p>
                                <p>{item.receipt_Count}</p>
                            </div>
                        </div>
                        {/* <div className="inline-data">
                            <p >Transfered</p> <p>{item.transfered_Count}</p>
                            <p >ReceiptCount</p> <p>{item.receipt_Count}</p>
                        </div> */}

                        <div className="disassemble-tiles-btn">
                           {/* {item.count===0 ?( */}
                           {item.transfered_Count < item.planned_Qty && (
                            <button className="button xs" onClick={() => handleTransferClick(item)} >{t('Posting')}</button>
                        )}
                           {/* ): */}
                           {item.count>0&&
                            <button className="button xs" onClick={() => handleReceiptClick(item)} >{t('Receipt')}</button>
                           }
                            
                            
                           
                        </div>
                    </div>
                )))}
        </div>
    );
};

export default ProductionFgTiles;

